import { Routes } from '@angular/router';
import { AuthGuard } from '@nova-portal/frontend-lib/firebase';
import { LoginPage } from '@nova-portal/frontend-lib/pages';

export const routes: Routes = [
	{
		path: '',
		pathMatch: 'full',
		redirectTo: 'desktop'
	},
	{
		path: 'desktop',
		canMatch: [AuthGuard],
		loadComponent: () => import('src/app/desktop/desktop.page').then(m => m.DesktopPage)
	},
	{
		path: 'catalogue',
		canMatch: [AuthGuard],
		loadComponent: () => import('src/app/catalogue/catalogue.page').then(m => m.CataloguePage)
	},
	{
		path: 'error',
		loadChildren: () => import('@nova-portal/frontend-lib/pages').then(m => m.errorRoutes)
	},
	{
		path: 'login',
		component: LoginPage
	},
	{
		path: '__/auth/',
		component: LoginPage
	},
	{
		path: '**',
		redirectTo: '/error/notfound'
	}
];
